import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import products from '../../data/products';
import './ProductDetail.css';

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find((p) => p.id === parseInt(id));
  const [selectedImage, setSelectedImage] = useState(0);

  if (!product) {
    return (
      <div className="pd__not-found">
        <p>Product not found.</p>
        <button onClick={() => navigate('/')}>Go back</button>
      </div>
    );
  }

  return (
    <div className="pd">
      <button className="pd__back" onClick={() => navigate(-1)}>← Back</button>

      <div className="pd__layout">
        {/* LEFT: thumbnail strip */}
        <div className="pd__thumbnails">
          {product.images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`${product.name} ${i + 1}`}
              className={`pd__thumb ${i === selectedImage ? 'pd__thumb--active' : ''}`}
              onClick={() => setSelectedImage(i)}
            />
          ))}
        </div>

        {/* CENTER: main image */}
        <div className="pd__main-image-wrapper">
          <img
            src={product.images[selectedImage]}
            alt={product.name}
            className="pd__main-image"
          />
        </div>

        {/* RIGHT: product info — Amazon-style sticky scroll */}
        <div className="pd__info-panel">
          <h1 className="pd__name">{product.name}</h1>
          <p className="pd__description">{product.description}</p>

          <div className="pd__divider" />

          <div className="pd__meta">
            <div className="pd__meta-row">
              <span className="pd__meta-label">Shelf Life</span>
              <span className="pd__meta-value">{product.shelfLife}</span>
            </div>
            <div className="pd__meta-row">
              <span className="pd__meta-label">Weight</span>
              <span className="pd__meta-value">{product.weight}</span>
            </div>
            <div className="pd__meta-row">
              <span className="pd__meta-label">Dimensions</span>
              <span className="pd__meta-value">{product.dimensions}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;